import {CommonModule, formatDate} from '@angular/common';
import {Component, OnInit} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {DatePickerModule} from 'primeng/datepicker';

import {ApiService} from '../../services/api.service';
import {
  SalesInstallationPartnerSelectComponent
} from '../../shared/sales-installation-partner-select/sales-installation-partner-select.component';

@Component({
    selector: 'app-lead-form',
    imports: [CommonModule, FormsModule, DatePickerModule, SalesInstallationPartnerSelectComponent],
    templateUrl: './lead-form.component.html',
    styleUrls: ['../lead-management.shared.css']
})
export class LeadFormComponent implements OnInit {
  leadId: number | null = null;
  isEdit = false;
  saving = false;
  assignees: any[] = [];

  model: any = {
    customer_name: '',
    contact_person: '',
    phone_number: '',
    email: '',
    whatsapp_number: '',
    company_type: '',
    city: '',
    state: '',
    address: '',
    entry_gates: 0,
    exit_gates: 0,
      approx_vehicle_count: 1000,
    existing_system: 'NONE',
    source: 'OTHER',
    sales_installation_partner: null,
    assigned_to: '',
    expected_closure_date: '',
    status: 'NEW',
    requirement_summary: '',
  };

  companyTypes = [
    ['HOTEL', 'Hotel'],
    ['APARTMENT', 'Apartment'],
    ['LOGISTICS', 'Logistics'],
    ['IT_PARK', 'IT Park'],
    ['HOSPITAL', 'Hospital'],
    ['FACTORY', 'Factory'],
    ['MALL', 'Mall'],
    ['OTHER', 'Other'],
  ];

  existingSystems = [
    ['NONE', 'None'],
    ['CCTV', 'CCTV'],
    ['MANUAL_REGISTER', 'Manual Register'],
    ['OTHER', 'Other'],
  ];

  sources = [
    ['INDIA_MART', 'IndiaMART'],
    ['WEBSITE', 'Website'],
    ['DIRECT_CALL', 'Direct Call'],
    ['WHATSAPP', 'WhatsApp'],
    ['REFERRAL', 'Referral'],
    ['SALES_INSTALLATION_PARTNER', 'Sales & Installation Partner'],
    ['OTHER', 'Other'],
  ];

  statuses = [
    ['NEW', 'New'],
    ['CONTACTED', 'Contacted'],
    ['REQUIREMENT_UNDERSTOOD', 'Requirement Understood'],
    ['DEMO_SCHEDULED', 'Demo Scheduled'],
    ['DEMO_COMPLETED', 'Demo Completed'],
    ['NEGOTIATION', 'Negotiation'],
      ['QUOTE_SENT', 'Quote Sent'],
    ['WON', 'Won'],
    ['LOST', 'Lost'],
    ['ON_HOLD', 'On Hold'],
  ];

  constructor(
    private apiService: ApiService,
    private route: ActivatedRoute,
    public router: Router,
  ) {}

  ngOnInit(): void {
    const id = this.route.snapshot.paramMap.get('id');
    this.loadAssignees();
    if (id) {
      this.leadId = Number(id);
      this.isEdit = true;
      this.loadLead(this.leadId);
    }
  }

  loadAssignees(): void {
    this.apiService.getAssignableUsers(1, 100, '').subscribe({
      next: (response: any) => {
          const results = response?.results || [];
          this.assignees = results.filter(
              (user: any) => user?.id && (user.username || user.first_name || user.last_name),
          );
      }
    });
  }

    assigneeLabel(assignee: any): string {
        const name = `${assignee?.first_name || ''} ${assignee?.last_name || ''}`.trim();
        return name || assignee?.username || 'Unknown';
    }

  loadLead(id: number): void {
    this.apiService.getLead(id).subscribe({
      next: (response: any) => {
        this.model = {
          ...this.model,
          ...response,
          assigned_to: response?.assigned_to || '',
          expected_closure_date: this.parseDate(response?.expected_closure_date),
        };
      }
    });
  }

  save(): void {
    if (!this.model.customer_name || !this.model.phone_number) {
      return;
    }

    const payload = {
      ...this.model,
      sales_installation_partner: this.model.source === 'SALES_INSTALLATION_PARTNER'
        ? (this.model.sales_installation_partner || null)
        : null,
      assigned_to: this.model.assigned_to || null,
        approx_vehicle_count: this.model.approx_vehicle_count ?? 1000,
      expected_closure_date: this.model.expected_closure_date ? this.serializeDate(this.model.expected_closure_date) : null,
    };

    this.saving = true;
    const request = this.isEdit && this.leadId
      ? this.apiService.updateLead(this.leadId, payload)
      : this.apiService.createLead(payload);

    request.subscribe({
      next: (response: any) => {
        this.saving = false;
        this.router.navigate([`lead-management/leads/${response.id || this.leadId}`]);
      },
      error: () => {
        this.saving = false;
      }
    });
  }

  private parseDate(value: string | null | undefined): Date | null {
    if (!value) {
      return null;
    }
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? null : date;
  }

  private serializeDate(value: Date | string): string {
    const date = value instanceof Date ? value : new Date(value);
    return formatDate(date, 'yyyy-MM-dd', 'en-IN');
  }

  get showPartnerField(): boolean {
    return this.model.source === 'SALES_INSTALLATION_PARTNER';
  }
}
